import { createAsyncThunk } from "@reduxjs/toolkit";

import * as URL from "helpers/url_helper";
import { get, post, put } from "helpers/api_helper";
import { toast } from "react-toastify";
import { getValuesSocketData } from "helpers/secretManager";

export const getSettings = createAsyncThunk(
  "getSettings",
  async (payload, Thunk) => {
    try {
      const { signature, nonce } = await getValuesSocketData();
      let response = await get(URL.GET_SETTINGS, { signature, nonce });

      return response.data;
    } catch (error) {
      return Thunk.rejectWithValue(error);
    }
  },
);

export const getGameSetting = createAsyncThunk(
  "getGameSetting",
  async (payload, Thunk) => {
    try {
      const { signature, nonce } = await getValuesSocketData();
      let response = await get(URL.GET_GAME_SETTINGS, { signature, nonce });

      // API helper returns { status: "success", data: {...} }
      // So we need to extract response.data which contains the actual game settings
      const gameData = response?.data;

      return gameData;
    } catch (error) {
      console.error("getGameSetting error:", error);
      return Thunk.rejectWithValue(error);
    }
  },
);

export const updateSettings = createAsyncThunk(
  "updateSetting",
  async ({ data, callback }, Thunk) => {
    try {
      const { signature, nonce } = await getValuesSocketData();

      let response = await post(URL.UPDATE_SETTINGS, data, {
        signature,
        nonce,
      });
      if (response?.status === "failure") {
        toast.error(response?.message || "Something went wrong!");

        return callback && callback(response?.message, null);
      }
      callback && callback(null, response.data);
      toast.success("Settings updated successfully!");
      return response.data;
    } catch (error) {
      toast.error(error?.message || "Something went wrong!");
      callback && callback(error);
      return Thunk.rejectWithValue(error);
    }
  },
);

//settings

export const updateGameSettings = createAsyncThunk(
  "updateGameSettings",
  async ({ data, callback }, Thunk) => {
    try {
      const { signature, nonce } = await getValuesSocketData();

      let response = await post(URL.UPDATE_GAME_SETTING, data, {
        signature,
        nonce,
      });
      if (response?.status === "failure") {
        toast.error(response?.message || "Something went wrong!");

        return callback && callback(response?.message, null);
      }
      callback && callback(null, response.data);
      toast.success("Settings updated successfully!");
      return response.data;
    } catch (error) {
      toast.error(error?.message || "Something went wrong!");
      callback && callback(error);
      return Thunk.rejectWithValue(error);
    }
  },
);

export const updateWelcomeBonusSettings = createAsyncThunk(
  "updateWelcomeBonusSettings",
  async ({ data, callback }, Thunk) => {
    try {
      const { signature, nonce } = await getValuesSocketData();
      let response = await post(URL.UPDATE_WELCOME_BONUS_SETTING, data, {
        signature,
        nonce,
      });
      if (response?.status === "failure") {
        toast.error(response?.message || "Something went wrong!");
        return callback && callback(response?.message, null);
      }
      toast.success("Settings updated successfully!");
      return response.data;
    } catch (error) {
      toast.error(error?.message || "Something went wrong!");
      callback && callback(error);
      return Thunk.rejectWithValue(error);
    }
  },
);

export const updateCryptoExchangeSettings = createAsyncThunk(
  "updateCryptoExchangeSettings",
  async ({ data, callback }, Thunk) => {
    try {
      const { signature, nonce } = await getValuesSocketData();
      let response = await post(URL.UPDATE_CRYPTO_EXCHANGE_SETTING, data, {
        signature,
        nonce,
      });
      if (response?.status === "failure") {
        toast.error(response?.message || "Something went wrong!");
        return callback && callback(response?.message, null);
      }
      toast.success("Settings updated successfully!");
      return response.data;
    } catch (error) {
      toast.error(error?.message || "Something went wrong!");
      callback && callback(error);
      return Thunk.rejectWithValue(error);
    }
  },
);

export const updateCryptoDepositSettings = createAsyncThunk(
  "updateCryptoDepositSettings",
  async ({ data, callback }, Thunk) => {
    try {
      const { signature, nonce } = await getValuesSocketData();
      let response = await post(URL.UPDATE_CRYPTO_DEPOSIT_SETTING, data, {
        signature,
        nonce,
      });
      if (response?.status === "failure") {
        toast.error(response?.message || "Something went wrong!");
        return callback && callback(response?.message, null);
      }
      toast.success("Settings updated successfully!");
      return response.data;
    } catch (error) {
      toast.error(error?.message || "Something went wrong!");
      callback && callback(error);
      return Thunk.rejectWithValue(error);
    }
  },
);

export const updateEnergySettings = createAsyncThunk(
  "updateEnergySettings",
  async ({ data, callback }, Thunk) => {
    try {
      const { signature, nonce } = await getValuesSocketData();

      let response = await post(URL.UPDATE_ENERGY_SETTING, data, {
        signature,
        nonce,
      });
      if (response?.status === "failure") {
        toast.error(response?.message || "Something went wrong!");

        return callback && callback(response?.message, null);
      }
      callback && callback(null, response.data);
      toast.success("Settings updated successfully!");
      return response.data;
    } catch (error) {
      toast.error(error?.message || "Something went wrong!");
      callback && callback(error);
      return Thunk.rejectWithValue(error);
    }
  },
);

export const updateLeaderboardSettings = createAsyncThunk(
  "updateLeaderboardSettings",
  async ({ data, callback }, Thunk) => {
    try {
      const { signature, nonce } = await getValuesSocketData();

      let response = await post(URL.UPDATE_LEADERBOARD_SETTING, data, {
        signature,
        nonce,
      });
      if (response?.status === "failure") {
        toast.error(response?.message || "Something went wrong!");

        return callback && callback(response?.message, null);
      }
      callback && callback(null, response.data);
      toast.success("Settings updated successfully!");
      return response.data;
    } catch (error) {
      toast.error(error?.message || "Something went wrong!");
      callback && callback(error);
      return Thunk.rejectWithValue(error);
    }
  },
);

export const updateMaintenanceSettings = createAsyncThunk(
  "updateMaintenanceSettings",
  async ({ data, callback }, Thunk) => {
    try {
      const { signature, nonce } = await getValuesSocketData();

      let response = await post(URL.UPDATE_MAINTENANCE_SETTING, data, {
        signature,
        nonce,
      });
      if (response?.status === "failure") {
        toast.error(response?.message || "Something went wrong!");

        return callback && callback(response?.message, null);
      }
      callback && callback(null, response.data);
      toast.success("Settings updated successfully!");
      return response.data;
    } catch (error) {
      toast.error(error?.message || "Something went wrong!");
      callback && callback(error);
      return Thunk.rejectWithValue(error);
    }
  },
);

export const updateHistoricalDataSettings = createAsyncThunk(
  "updateHistoricalDataSettings",
  async ({ data, callback }, Thunk) => {
    try {
      const { signature, nonce } = await getValuesSocketData();

      let response = await post(URL.UPDATE_HISTORICAL_DATA_SETTING, data, {
        signature,
        nonce,
      });
      if (response?.status === "failure") {
        toast.error(response?.message || "Something went wrong!");

        return callback && callback(response?.message, null);
      }
      callback && callback(null, response.data);
      toast.success("Settings updated successfully!");
      return response.data;
    } catch (error) {
      toast.error(error?.message || "Something went wrong!");
      callback && callback(error);
      return Thunk.rejectWithValue(error);
    }
  },
);

export const updateConversionSettings = createAsyncThunk(
  "updateConversionSettings",
  async ({ data, callback }, Thunk) => {
    try {
      const { signature, nonce } = await getValuesSocketData();
      let response = await post(URL.UPDATE_CRYPTO_CONVERSION_SETTING, data, {
        signature,
        nonce,
      });
      if (response?.status === "failure") {
        toast.error(response?.message || "Something went wrong!");
        return callback && callback(response?.message, null);
      }
      toast.success("Settings updated successfully!");
      return response.data;
    } catch (error) {
      toast.error(error?.message || "Something went wrong!");
      callback && callback(error);
      return Thunk.rejectWithValue(error);
    }
  },
);

export const updatePromotionSettings = createAsyncThunk(
  "updatePromotionSettings",
  async ({ data, callback }, Thunk) => {
    try {
      const { signature, nonce } = await getValuesSocketData();
      let response = await post(URL.UPDATE_PROMOTION_SETTING, data, {
        signature,
        nonce,
      });
      if (response?.status === "failure") {
        toast.error(response?.message || "Something went wrong!");
        return callback && callback(response?.message, null);
      }
      toast.success("Settings updated successfully!");
      return response.data;
    } catch (error) {
      toast.error(error?.message || "Something went wrong!");
      callback && callback(error);
      return Thunk.rejectWithValue(error);
    }
  },
);

export const updatePaymentSettings = createAsyncThunk(
  "updatePaymentSettings",
  async ({ data, callback }, Thunk) => {
    try {
      const { signature, nonce } = await getValuesSocketData();
      let response = await post(URL.UPDATE_PAYMENT_SETTINGS, data, {
        signature,
        nonce,
      });
      if (response?.status === "failure") {
        toast.error(response?.message || "Something went wrong!");
        return callback && callback(response?.message, null);
      }
      toast.success("Settings updated successfully!");
      return response.data;
    } catch (error) {
      toast.error(error?.message || "Something went wrong!");
      callback && callback(error);
      return Thunk.rejectWithValue(error);
    }
  },
);

export const updateBuyEnergySettings = createAsyncThunk(
  "updateBuyEnergySettings",
  async ({ data, callback }, Thunk) => {
    try {
      const { signature, nonce } = await getValuesSocketData();
      let response = await post(URL.UPDATE_BUYENERGY_SETTINGS, data, {
        signature,
        nonce,
      });
      if (response?.status === "failure") {
        toast.error(response?.message || "Something went wrong!");
        return callback && callback(response?.message, null);
      }
      toast.success("Settings updated successfully!");
      return response.data;
    } catch (error) {
      toast.error(error?.message || "Something went wrong!");
      callback && callback(error);
      return Thunk.rejectWithValue(error);
    }
  },
);

export const updateRewardSystemSettings = createAsyncThunk(
  "updateRewardSystemSettings",
  async ({ data, callback }, Thunk) => {
    try {
      const { signature, nonce } = await getValuesSocketData();
      let response = await post(URL.UPDATE_REWARD_SETTINGS, data, {
        signature,
        nonce,
      });
      if (response?.status === "failure") {
        toast.error(response?.message || "Something went wrong!");
        return callback && callback(response?.message, null);
      }
      toast.success("Settings updated successfully!");
      return response.data;
    } catch (error) {
      toast.error(error?.message || "Something went wrong!");
      callback && callback(error);
      return Thunk.rejectWithValue(error);
    }
  },
);

export const updateJackpotSettings = createAsyncThunk(
  "updateJackpotSettings",
  async ({ data, callback }, Thunk) => {
    try {
      const { signature, nonce } = await getValuesSocketData();
      let response = await post(URL.UPDATE_JACKPOT_SETTINGS, data, {
        signature,
        nonce,
      });
      if (response?.status === "failure") {
        toast.error(response?.message || "Something went wrong!");
        return callback && callback(response?.message, null);
      }
      toast.success("Settings updated successfully!");
      return response.data;
    } catch (error) {
      toast.error(error?.message || "Something went wrong!");
      callback && callback(error);
      return Thunk.rejectWithValue(error);
    }
  },
);

export const updateWeeklyRewardHistory = createAsyncThunk(
  "updateWeeklyRewardHistory",
  async ({ data, callBack }, Thunk) => {
    try {
      const { signature, nonce } = await getValuesSocketData();
      let response = await put(URL.UPDATE_WEEKLY_REWARD + data?._id, data, {
        signature,
        nonce,
      });
      if (response?.status === "failure") {
        toast.error(response?.message || "Something went wrong!");
        return callBack && callBack(response?.message, null);
      }
      toast.success("Settings updated successfully!");
      callBack && callBack(null, response);
      return response.data;
    } catch (error) {
      toast.error(error?.message || "Something went wrong!");
      callBack && callBack(error);
      return Thunk.rejectWithValue(error);
    }
  },
);

export const getWeeklyRewardHistory = createAsyncThunk(
  "getWeeklyRewardHistory",
  async ({ data, callback }, Thunk) => {
    try {
      const { signature, nonce } = await getValuesSocketData();
      let response = await post(URL.WEEKLY_REWARD_HISTORY, data, {
        signature,
        nonce,
      });
      if (response.status === "failure") {
        toast.error(response?.message);
        return Thunk.rejectWithValue(response?.message);
      }
      callback && callback(null, response);
      return response;
    } catch (error) {
      toast.error(error?.message || "Something went wrong!");
      callback && callback(error);
      return Thunk.rejectWithValue(error);
    }
  },
);

export const getWeeklyRewardDetails = createAsyncThunk(
  "getWeeklyRewardDetails",
  async ({ data, callBack }, Thunk) => {
    try {
      const { signature, nonce } = await getValuesSocketData();
      let response = await get(URL.UPDATE_WEEKLY_REWARD + data?._id, {
        signature,
        nonce,
      });
      if (response.status === "failure") {
        toast.error(response?.message);
        return Thunk.rejectWithValue(response?.message);
      }
      callBack && callBack(null, response);
      return response;
    } catch (error) {
      toast.error(error?.message || "Something went wrong!");
      callBack && callBack(error);
      return Thunk.rejectWithValue(error);
    }
  },
);

export const recalculateRewards = createAsyncThunk(
  "recalculateRewards",
  async ({ data, callBack }, Thunk) => {
    try {
      const { signature, nonce } = await getValuesSocketData();
      let response = await post(URL.RECALCULATE_WEEKLY_REWARD, data, {
        signature,
        nonce,
      });
      if (response.status === "failure") {
        toast.error(response?.message);
        return Thunk.rejectWithValue(response?.message);
      }
      callBack && callBack(null, response);
      return response;
    } catch (error) {
      toast.error(error?.message || "Something went wrong!");
      callBack && callBack(error);
      return Thunk.rejectWithValue(error);
    }
  },
);

export const getBombLineCount = createAsyncThunk(
  "Get Bomb Line Count",
  async (payload, Thunk) => {
    try {
      const { signature, nonce } = await getValuesSocketData();
      let response = await get(URL.GET_BOMB_LINE_COUNT, { signature, nonce });

      // Your API returns: { success: true, data: [...] }
      // Extract the data array
      const bombCountData = response?.data || [];

      // Return in the format expected by slice: { data: [...] }
      return { data: bombCountData };
    } catch (error) {
      console.error("getBombLineCount error:", error);
      return Thunk.rejectWithValue(
        error?.response?.data ||
          error?.message ||
          "Failed to fetch bomb line count",
      );
    }
  },
);

export const getExportRequestList = createAsyncThunk(
  "getExportRequestList",
  async ({ data, callback }, Thunk) => {
    try {
      const { signature, nonce } = await getValuesSocketData();
      let response = await post(`${URL.GET_EXPORT_REQUEST_LIST}`, data, {
        signature,
        nonce,
      });
      callback && callback(null, response.data);
      return response;
    } catch (error) {
      return Thunk.rejectWithValue(error);
    }
  },
);

export const getCoinHistoryList = createAsyncThunk(
  "getCoinHistoryList",
  async ({ data, callback }, Thunk) => {
    try {
      const { signature, nonce } = await getValuesSocketData();
      let response = await post(`${URL.GET_COIN_HISTORY_LIST}`, data, {
        signature,
        nonce,
      });
      callback && callback(null, response.data);
      return response;
    } catch (error) {
      return Thunk.rejectWithValue(error);
    }
  },
);
